<template>
  <div class="detail-dialog-header">
    <div class="detail-dialog-header__main">
      <div class="detail-dialog-header__icon">
        <i class="detail-dialog-header__icon-font t-iconfont" :class="showDesc.icon"></i>
      </div>
      <div class="detail-dialog-header__content">
        <span class="detail-dialog-header__subtitle">{{ showDesc.name }}拜访轨迹</span>
        <div class="detail-dialog-header__title-row">
          <span class="detail-dialog-header__title-text">{{ showName }}</span>
          <el-tooltip
            v-if="isShowCRMDetail"
            class="box-item"
            content="打开 CRM 详情页"
            effect="dark"
            placement="top"
          >
            <i
              class="detail-dialog-header__crm-icon icon-login-box-line t-iconfont"
              @click="openDetail"
            ></i>
          </el-tooltip>
        </div>
      </div>
      <div v-if="showLinkLarkButton" class="detail-dialog-header__operate">
        <button class="detail-dialog-header__operate-btn" type="button" @click="handleLinkLark">
          关联飞书群聊
        </button>
      </div>
      <div v-if="saleOrderProcessPermission" class="detail-dialog-header__actions">
        <TabSlide v-model:value="activName" :options="detailMode" />
      </div>
    </div>
    <div class="detail-dialog-header__meta">
      <template v-for="(desc, index) in titleDesc" :key="index">
        <div v-if="index !== 0" class="detail-dialog-header__separator"></div>
        <div class="detail-dialog-header__meta-item">
          <div class="detail-dialog-header__meta-label">{{ desc.key }}</div>
          <template v-if="[0, 1, 2].includes(desc.isRisk)">
            <div class="detail-dialog-header__risk">
              <div
                class="detail-dialog-header__risk-dot"
                :class="{
                  'detail-dialog-header__risk-dot--success': desc.isRisk === 0,
                  'detail-dialog-header__risk-dot--risk': desc.isRisk === 1,
                  'detail-dialog-header__risk-dot--gray': desc.isRisk === 2
                }"
              ></div>
              <div class="detail-dialog-header__meta-value">{{ desc.value }}</div>
            </div>
          </template>
          <div
            v-else-if="desc.dataId"
            class="detail-dialog-header__meta-value detail-dialog-header__meta-value--link"
            @click="openCustomerDetail(desc)"
          >
            {{ desc.value }}
          </div>
          <div v-else class="detail-dialog-header__meta-value">{{ desc.value }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import TabSlide from '@/pages/ai-board/components/components/ai-detail-dialog/components/tab-slide.vue'
import xbbSdk from 'xbb-sdk'
import { getLarkGroupOpenStatus } from '@/api/ai-board'

const props = defineProps({
  detailType: {
    type: String,
    default: 'customer'
  },
  showName: {
    type: String,
    default: ''
  },
  inxbb: {
    type: Boolean,
    default: false
  },
  titleDesc: {
    type: Array,
    default: () => []
  },
  deatilData: {
    type: Object,
    default: () => ({})
  },
  activMode: {
    type: String,
    default: ''
  },
  saleOrderProcessPermission: {
    // 销售订单分析权限
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['update:activMode', 'changeMode', 'linkLark'])

const route = useRoute()

const showDesc = computed(() => {
  const typeEnum = {
    customer: {
      name: '客户',
      icon: 'icon-pass-pending-fill'
    },
    opportunity: {
      name: '商机',
      icon: 'icon-cash-fill'
    },
    clue: {
      name: '线索',
      icon: 'icon-git-branch-line'
    }
  }
  return typeEnum[props.detailType]
})
// 是否显示打开CRM详情页入口
const isShowCRMDetail = computed(() => route.name !== 'proVisitDetail')

const activName = computed({
  get: () => props.activMode,
  set: (val) => {
    emits('update:activMode', val)
    emits('changeMode', val)
  }
})

const detailMode = ref([
  { name: '打单分析', key: 'orderAnalysis', icon: 'icon-edit2-ai-line' },
  { name: '跟进诊断', key: 'followupDiagnosis', icon: 'icon-focus3-ai-line' }
])

const isLarkGroupOpen = ref(false)
const showLinkLarkButton = computed(
  () => ['customer', 'opportunity'].includes(props.detailType) && isLarkGroupOpen.value
)

const getLarkGroupOpenStatusData = () => {
  getLarkGroupOpenStatus().then((res) => {
    if (res.success) {
      isLarkGroupOpen.value = res.result?.status === 1
    }
  })
}

onMounted(() => {
  getLarkGroupOpenStatusData()
})

const openDetail = () => {
  if (props.inxbb) {
    if (props.detailType === 'customer') {
      xbbSdk.sendMessage('openDetailPage', {
        appId: props.deatilData.appId,
        dataId: props.deatilData.customerId,
        saasMark: 1,
        businessType: 100,
        subBusinessType: 101,
        uuid: xbbSdk.props.uuid
      })
    } else if (props.detailType === 'opportunity') {
      xbbSdk.sendMessage('openDetailPage', {
        appId: props.deatilData.appId,
        dataId: props.deatilData.opportunityId,
        saasMark: 1,
        businessType: 301,
        subBusinessType: 302,
        uuid: xbbSdk.props.uuid
      })
    } else if (props.detailType === 'clue') {
      xbbSdk.sendMessage('openDetailPage', {
        appId: props.deatilData.appId,
        dataId: props.deatilData.clueId || props.deatilData.customerId,
        saasMark: 1,
        businessType: 8000,
        subBusinessType: 8001,
        uuid: xbbSdk.props.uuid
      })
    }
  } else {
    console.log('不在销帮帮')
  }
}

const openCustomerDetail = (desc) => {
  if (props.inxbb) {
    xbbSdk.sendMessage('openDetailPage', {
      appId: props.deatilData.appId,
      dataId: desc.dataId,
      saasMark: 1,
      businessType: 100,
      subBusinessType: 101,
      uuid: xbbSdk.props.uuid
    })
  }
}

const handleLinkLark = () => {
  emits('linkLark')
}
</script>

<style lang="scss" scoped>
.detail-dialog-header {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  &__main {
    margin-right: 30px;
    display: flex;
    position: relative;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 42px;
    height: 42px;
    margin-right: 12px;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
    background: #f5e8ff;
    border-radius: 12px;
  }

  &__icon-font {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    font-size: 20px;
    color: #7a52f4;
  }

  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;
    font-family: PingFang SC;
  }

  &__subtitle {
    margin-bottom: 2px;
    font-size: 13px;
    line-height: 18px;
    color: #646566;
  }

  &__title-row {
    display: flex;
    align-items: center;
    font-size: 18px;
    position: relative;
  }

  &__title-text {
    font-weight: 600;
    line-height: 26px;
    color: #323233;
    margin-right: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__crm-icon {
    color: #248df5;
    cursor: pointer;
  }

  &__operate {
    margin-left: 24px;
    flex: 0 0 auto;
    align-self: center;
    height: fit-content;
  }

  &__operate-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 6px 12px;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #646566;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;
  }

  &__actions {
    margin-left: 24px;
    flex: 0 0 auto;
    align-self: center;
    height: fit-content;
  }

  &__meta {
    display: flex;
    margin-top: 8px;
    background: #f7f8fa;
    border-radius: 8px;
    padding: 10px 12px;
    align-items: center;
  }

  &__separator {
    flex: 0 0 auto;
    width: 2px;
    height: 12px;
    margin: 0 24px;
    background: #e5e6eb;
  }

  &__meta-item {
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    font-family: PingFang SC;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
  }

  &__meta-label {
    color: #969799;
    margin-right: 12px;
    flex: 0 0 auto;
  }

  &__meta-value {
    color: #323233;
    flex: 1;
    overflow: hidden;

    &--link {
      cursor: pointer;
      color: #248df5;
    }
  }

  &__risk {
    display: flex;
    align-items: center;
    background: #f2f3f5;
    border-radius: 4px;
    padding: 2px 8px;
  }

  &__risk-dot {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    margin-right: 8px;

    &--risk {
      background: #fc5555;
    }

    &--success {
      background: #0fbb54;
    }

    &--gray {
      background: #c9cdcd;
    }
  }
}
</style>
